export const planStateStatuses = {
    "EXPECTATION": "Ожидание",
    "PLANNED": "Спланирован",
    "WORK": "В работе",
    "ARCHIVE": "Архив"
}